import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../Button/Button';
import styles from './DonateButton.module.css';

const DonateButton = ({ onClick, className = '', ...props }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);               // custom behavior (e.g., close menu + navigate)
    } else {
      navigate('/donate');       // default navigation to donate page
    }
  };

  return (
    <Button
      variant="primary"
      size="medium"
      onClick={handleClick}
      className={`${styles.donateBtn} ${className}`}
      {...props}
    >
      Donate Now
    </Button>
  );
};

export default DonateButton;